<div class="permissions">
  <!-- one tenant: a plain card, nothing to unfold -->
  <section class="card qa-perm-card" *ngIf="tenants.length === 1; else tenantAccordion">
    <div class="card-body">
      <div class="qa-perm-head">
        <h3>{{_(KEYS.CRUD.ROLES)}}</h3>
        <span class="qa-perm-tenant"><i class="fa fa-copy" aria-hidden="true"></i> {{_(KEYS.CRUD.TENANT)}}: {{tenants[0].name}}</span>
      </div>
      <ng-container *ngTemplateOutlet="rolesTable; context: {$implicit: tenants[0]}"></ng-container>
    </div>
  </section>

  <!-- several tenants: one panel per tenant -->
  <ng-template #tenantAccordion>
    <ngb-accordion [closeOthers]="true" [activeIds]="activePanelId ? [activePanelId] : []">
      <ngb-panel
        *ngFor="let tenant of tenants"
        [id]="tenant.tenantId ? tenant.tenantId + '' : 'all-tenant'"
        [disabled]="!user || !user.userId">
        <ng-template ngbPanelHeader>
          <button type="button" ngbPanelToggle class="mm-pane-toggle mm-permission-toggle">
            <span class="mm-pane-toggle-label">
              <i class="fa fa-copy" aria-hidden="true"></i>
              <span>{{_(KEYS.CRUD.TENANT)}}: {{tenant.name}}</span>
            </span>
            <span class="mm-pane-toggle-icon" aria-hidden="true"><i class="fa toggle"></i></span>
          </button>
        </ng-template>

        <ng-template ngbPanelContent>
          <div class="qa-perm-head"><h3>{{_(KEYS.CRUD.ROLES)}}</h3></div>
          <ng-container *ngTemplateOutlet="rolesTable; context: {$implicit: tenant}"></ng-container>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </ng-template>

  <ng-template #rolesTable let-tenant>
    <table class="table">
      <thead>
      <tr>
        <th>{{_(KEYS.CRUD.ROLE)}}</th>
        <th>{{_(KEYS.CRUD.DESCRIPTION)}}</th>
        <th class="qa-perm-assign">
          {{canUserManageUserRolesMap[tenant.tenantId] ? _(KEYS.CRUD.ASSIGN) : _(KEYS.CRUD.ASSIGNED)}}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let role of roles" [class.qa-perm-on]="userTenantRoleMap[tenant.tenantId][role.roleId]">
        <td class="qa-perm-role">{{_(role.name)}}</td>
        <td class="qa-perm-description">{{_(role.description)}}</td>
        <td class="qa-perm-assign">
          <input
            type="checkbox"
            class="qa-switch"
            role="switch"
            [attr.aria-label]="_(role.name)"
            (change)="onUpdateUserRole(tenant, role)"
            [(ngModel)]="userTenantRoleMap[tenant.tenantId][role.roleId]"
            [attr.disabled]="canUserManageUserRolesMap[tenant.tenantId] === false ? false : null">
        </td>
      </tr>
      </tbody>
    </table>
  </ng-template>
</div>
